import { useEffect, useMemo, useState } from "react";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";


const useDashboardTable = () => {
  const [tableData, setTableData] = useState([]);

  // fetch table dataa
  const fetchTabledata = async () => {
    try {
      const response = await apiService.get(`/tables?active=true`);
      setTableData(response.data);
    } catch (errors) {
      handleError(errors)
    }
  };
  
  useEffect(() => {
    fetchTabledata();
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "TABLE NAME", 
        accessor: "name",
      },
      {
        Header: "STATUS",
        accessor: "status",
        // disableSortBy: true ,
        Cell: ({ row }) => {
          return (
            <p
              className={`text-xs md:text-sm font-medium flex justify-center items-center rounded-3xl w-[100px] md:w-auto px-4 py-[6px] 
              ${
                row.original.status === "Occupied"
                  ? "text-blue bg-blue bg-opacity-[10%]"
                  : "text-red bg-red bg-opacity-[10%]"
              }`}
            >
              {row.original.status}
            </p>
          );
        },
      },
    ],
    []
  );
  const data = useMemo(() => {
    if (!Array.isArray(tableData)) return [];

    return tableData.map((table) => ({
        ...table,
        status:table.status === "idle" ? "Idle":"Occupied" ,
      }));
  }, [tableData]);

  return { columns, data };
};

export default useDashboardTable;
